import React from "react";
import { useNavigate } from "react-router-dom";

const AddAppointmentModal = ({ show, onClose }) => {
  const navigate = useNavigate(); // Hook must come before any conditional return

  if (!show) return null; // Safe now — hook already declared

  const handleAddProviderAppointment = () => {
    onClose(); // Close modal
    navigate("/AddAppointmentPage"); // Navigate to Add Appointment Page
  };

  const handleScheduleConsult = () => {
    onClose();
    navigate("/book-appointment"); // Optional route for scheduling
  };

  return (
    <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
           {/* <h5 className="modal-title">Pregnancy Assessment</h5>*/}
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <h5 style={{fontSize:"1.2rem"}}>Schedule a consult or add provider appointment details so we can offer the Personalized guidance.</h5>
            <div className="d-flex flex-column gap-2">
              <button className="win-btn-primary-full" onClick={handleScheduleConsult}>Schedule a consult</button>
              <button className="win-btn-primary-full" onClick={handleAddProviderAppointment}>Add Provider Appointment</button>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAppointmentModal;
